export function textTemplateVideo() {
    $("video").each(function () {
        $(this).addClass("container");
        const sourse = $(this).attr("src") || $(this).find("Source:first").attr("src");
        const poster = $(this).attr("poster");
        $(this).replaceWith(function () {
            return ` <div class="single-video container">
                <div class="video-innner">
                    <div class="play-button"><svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="44" cy="44" r="44" fill="#2968F3"/><path d="M36 33V57Z" stroke="white" stroke-width="2" stroke-linecap="round"/><path d="M57 45L36 57Z" stroke="white" stroke-width="2" stroke-linecap="round"/><path d="M57 45L36 33Z" stroke="white" stroke-width="2" stroke-linecap="round"/></svg> </div>
                    <div class="video-hoder">
                        <video poster="${poster}">
                            <source src="${sourse}" type="video/mp4">
                        </video>
                    </div>
                </div>
            </div>  `;
        });
        $(".video-innner").each(function () {
            const playButton = $(this).find(".play-button");
            const video = $(this).find("video");
            playButton.on("click", function () {
                video[0].play();
                playButton.remove();
                video[0].setAttribute("controls", "controls");
            });
        });
    });

    setTimeout(() => {

        $(".text-template-container img").each(function () {
            $(this).addClass("container full-width");
        });
    },10)
};
export function articleVideoClick() {
    $(".video-innner").each(function () {
        const playButton = $(this).find(".play-button");
        const video = $(this).find("video");
        playButton.on("click", function () {
            video[0].play();
            playButton.remove();
            video[0].setAttribute("controls", "controls");
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/textTemplateVideo.js